var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoverImage2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 696.08 193.11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a3cfd9;}.cls-2{fill:#338598;}.cls-3{fill:#fff;}.cls-4{fill:#043e4b;opacity:0.49;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "338.67 97.34 7.79 182.81 7.79 97.34 338.67 97.34"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 345.29,
    y: -260.17,
    width: 10,
    height: 712.85,
    transform: "translate(167.4 410.14) rotate(-75.14)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -5.32,
    y: 92.09,
    width: 708.06,
    height: 10,
    transform: "translate(-13.24 93.11) rotate(-14.93)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "44.58 115.18 44.78 136.82 37.78 132.7 33.45 137.65 45.2 151.46 49.94 159.5 67.66 159.08 73.02 148.78 70.55 132.91 53.23 129.61 52.41 112.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.45,148.36a2.22,2.22,0,0,0,.15-.8v-7.27a6.41,6.41,0,0,0-5-6.28l-14.23-3.16V116.34a2.14,2.14,0,1,0-4.27,0v26.52L40.25,136a2.4,2.4,0,0,0-3.39,3.39L46,148.52a6.24,6.24,0,0,1,1.2,1.64l3.37,6.75H67Zm-27.62-32a6.41,6.41,0,1,1,12.82,0h0v11.1l10.86,2.42a10.68,10.68,0,0,1,8.37,10.43v7.27a6.42,6.42,0,0,1-.46,2.38l-4.51,11.27h-22l-4.54-9.13a2.42,2.42,0,0,0-.4-.55l-9.14-9.11a6.67,6.67,0,0,1,9-9.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M324,100.7H312v-6h12Zm-24,0H288v-6h12Zm-24,0H264v-6h12Zm-24,0H240v-6h12Zm-24,0H216v-6h12Zm-24,0H192v-6h12Zm-24,0H168v-6h12Zm-24,0H144v-6h12Zm-24,0H120v-6h12Zm-24,0H96v-6h12Zm-24,0H72v-6H84Zm-24,0H48v-6H60Zm-24,0H24v-6H36Zm-24,0H0v-6H12Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoverImage2);
export default __webpack_public_path__ + "static/media/coverImage2.30d6a26f6e73bb357b9ddc32e303884f.svg";
export { ForwardRef as ReactComponent };